import {useState} from "react";
import TopBar from "./TopBar";
import styles from './Create.css';
import {options} from "./const";

export default function SubmitQuestion({title, problems, setProblems}) {

    const [value, setValue] = useState(-1)

    const add = () => {
        if (value === options[0].label) setProblems((prevState) => [
            ...prevState,
            {
                title: "",
                selections: ["", "", "", ""],
                answer: '정답',
                type: options.filter(it => it.label === value)[0].key,
                difficulty: "난이도",
                score: 0
            }
        ])
        else if (value === options[1].label) setProblems((prevState) => [
            ...prevState, {
                title: "",
                selections: ["O", "X"],
                type: options.filter(it => it.label === value)[0].key,
                answer: 1,
                difficulty: "난이도",
                score: 0
            }
        ])
        else if (value === options[2].label) setProblems((prevState) => [
            ...prevState, {
                title: "",
                answers: ["", "", "", ""],
                difficulty: "난이도",
                score: 0,
                type: options.filter(it => it.label === value)[0].key,
                allowTypo: false,
                allowSpacingTypo: false,
            }
        ])
        else if (value === options[3].label) setProblems((prevState) => [
            ...prevState, {
                title: "",
                selections: ["", "", "", ""],
                type: options.filter(it => it.label === value)[0].key,
            }
        ])
        else if (value === options[4].label) setProblems((prevState) => [
            ...prevState, {
                title: "",
                selections: ["", "", "", ""],
                type: options.filter(it => it.label === value)[0].key,
            }
        ])
    }

    return (
        <div id="submitShort">
            <TopBar value={value} setValue={setValue} title={title} add={add}/>
            {Array.isArray(problems) && problems.length > 0 && problems?.map((it, index) => (
                <section key={`${it.type}${index}`} className="problemSection section p-6">
                    <div className="problemContainer">
                        <div style={{display: "flex"}}>
                            <span style={styles.index}>{String(index + 1).padStart(2, "0").padEnd(3, ".")}</span>
                            <input className={"inputBorder inputTextAreaMargin"} key={`${index}SQI`}
                                   placeholder="문제를 입력하는 곳입니다." disabled/>
                        </div>
                        {it.selections?.map((i, ind) => (
                            <div key={`${it.type}${ind}${index}SQPS`}
                                 style={{marginLeft: "20px", display: "flex"}}>
                                {it.type === options[0].key ? <span style={styles.index}>{ind + 1}</span> :
                                    it.type === options[3].key ? <img src="/images/radio.svg"/> :
                                        it.type === options[4].key ? <img src="/images/select.svg"/> : null}
                                {it.type === options[1].key ? i :
                                    <input className={"inputBorder inputTextAreaMargin"} key={`${index}${ind}SQI`}
                                           placeholder={it.type === options[1].key ? i :
                                               "보기" + (ind + 1) + "번"} disabled/>}</div>
                        ))}
                        {it.answers?.map((i, ind) => (
                            <div key={String(index).padStart(2, "0").padEnd(3, ".") + ind.toString()}
                                 style={{marginLeft: "20px", display: "flex"}}>
                                <span style={styles.index}>정답</span>
                                <input className={"inputBorder inputTextAreaMargin"}
                                       placeholder={"정답을 입력하는 곳입니다."} disabled/>
                            </div>
                        ))}
                    </div>
                </section>
            ))}
            <div className="saveContainer">
            </div>
        </div>
    )
}
